import { META } from "npmlinks-constants";

const normaliseUrlFromInvalidCases = (search = "") =>
  (search &&
    search
      .split("+")
      .join("%20")
      .split("%%")
      .join("%25%")) ||
  "";
const gethostdomainpath = passedUrl => {
  // TODO:: need to check later regex got modified
  // const [url, domain, path] = new RegExp(DOMAINREGEX).exec(passedUrl);
  const [url, domain, path] = /^(?:\w+\:\/\/)?([^\/]+)(.*)$/.exec(passedUrl);
  return {
    url,
    domain,
    path,
  };
};
const queryParamsToObject = (search = "") => {
  try {
    const hashes =
      normaliseUrlFromInvalidCases(search)
        .slice(search.indexOf("?") + 1)
        .split("&") || [];
    const params = {};
    hashes.map(hash => {
      const [key, val] = hash.split("=");
      params[key] = decodeURIComponent(val);
      return null;
    });
    Object.keys(params).forEach(key => {
      if (!key) {
        delete params[key];
      }
    });
    return params;
  } catch (error) {
    console.log(error);
    return {};
  }
};

const makeUrlAbsolute = (url = "") =>
  (url.indexOf(".com") < 0 && `${window.location.origin}${url}`) || url;

function removeProtocolWww(urlTemp = "") {
  let url = urlTemp;
  const presentInStarting = (string, substring) =>
    string.indexOf(substring) === 0;
  if (presentInStarting(url, META.HTTPS)) {
    url = url.substring(META.HTTPS.length);
  } else if (presentInStarting(url, META.HTTP)) {
    url = url.substring(META.HTTP.length);
  }
  if (presentInStarting(url, META.defaultSubDomainWww)) {
    url = url.substring(META.defaultSubDomainWww.length);
  }
  return url;
}

const cacheQueryParser = (query) => {
  let out = "";
  if (typeof query === "string") {
    out = query.split(":").pop().replace(/^[^/]*/, "") || "";
  }
  return out;
};

export {
  gethostdomainpath,
  queryParamsToObject,
  makeUrlAbsolute,
  normaliseUrlFromInvalidCases,
  removeProtocolWww,
  cacheQueryParser,
};
export default gethostdomainpath;



// WEBPACK FOOTER //
// ./src/utils/url.js